import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0B0F14', color: '#E6EDF3' }}>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 mb-8"
        >
          <ArrowLeft size={20} />
          Zurück zur Startseite
        </Link>

        <h1 className="text-4xl font-bold mb-8" style={{ color: '#1EA0E6' }}>
          Impressum
        </h1>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              Angaben gemäß § 5 TMG
            </h2>
            <div className="space-y-2">
              <p><strong>Betreiber:</strong></p>
              <p>Andreas Trenter</p>
              <p>STR-Performance</p>
              <p>Dorfweg 8</p>
              <p>4718 Holderbank</p>
              <p>Schweiz</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              Kontakt
            </h2>
            <p><strong>E-Mail:</strong> support@carcortex-ai.com</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p>Andreas Trenter</p>
            <p>Dorfweg 8</p>
            <p>4718 Holderbank</p>
            <p>Schweiz</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              Haftungsausschluss
            </h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">Haftung für Inhalte</h3>
            <p className="mb-4">
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. 
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
              nach den allgemeinen Gesetzen verantwortlich.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Keine Gewährleistung für KI-Diagnosen</h3>
            <p className="mb-4 font-semibold" style={{ color: '#FFA500' }}>
              WICHTIGER HINWEIS: Die auf dieser Plattform bereitgestellten Diagnose-Vorschläge und 
              Reparaturhinweise sind ausschließlich als HILFESTELLUNG zu verstehen und ersetzen NICHT 
              die professionelle Diagnose durch eine qualifizierte Fachwerkstatt.
            </p>
            <p className="mb-4">
              Die KI-gestützten Diagnosevorschläge basieren auf allgemeinen Erfahrungswerten und können 
              keine herstellerspezifischen, fahrzeugindividuellen oder situationsbedingten Besonderheiten 
              berücksichtigen. Jede Durchführung von Reparaturen erfolgt auf eigene Verantwortung und 
              eigenes Risiko des Nutzers.
            </p>
            <p className="mb-4">
              Wir übernehmen keinerlei Haftung für Schäden, die durch die Befolgung der auf dieser 
              Plattform bereitgestellten Diagnose- und Reparaturhinweise entstehen. Dies gilt insbesondere 
              für:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>Sachschäden am Fahrzeug</li>
              <li>Personenschäden</li>
              <li>Folgeschäden durch fehlerhafte Diagnosen oder Reparaturen</li>
              <li>Verlust von Garantieansprüchen</li>
              <li>Verstoß gegen gesetzliche Vorschriften oder Herstellervorgaben</li>
            </ul>
            <p className="mb-4">
              Für sicherheitskritische Systeme (z.B. Bremsen, Lenkung, Airbags) empfehlen wir 
              ausdrücklich die Konsultation einer Fachwerkstatt.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Haftung für Links</h3>
            <p className="mb-4">
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen 
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
              Seiten verantwortlich.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Urheberrecht</h3>
            <p className="mb-4">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
              dem Schweizer und europäischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung 
              und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der 
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              Online-Streitbeilegung (OS)
            </h2>
            <p className="mb-4">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
            </p>
            <a 
              href="https://ec.europa.eu/consumers/odr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 underline"
            >
              https://ec.europa.eu/consumers/odr
            </a>
            <p className="mt-4">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <div className="mt-12 pt-8 border-t" style={{ borderColor: '#1F2937' }}>
            <p className="text-sm text-gray-400">
              Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;
